const thumbnails = {};

export function getFromCache(id){
  return thumbnails[id];
}

export function setInCache(id, src){
  thumbnails[id] = src;
}